import { Loader } from "./Loader";

export function SpinnerLoaderWrapper() {
  return (
    <div className="h-full flex justify-content-center align-items-center">
      <Loader type="spinner" />
    </div>
  );
}
